(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icandy-car-seat-compatibility"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.icc');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var dataUrl = section.getAttribute('data-data-url');
      var bbDataUrl = section.getAttribute('data-bb-data-url');
      var input = section.querySelector('.icc-search__input');
      var clearBtn = section.querySelector('.icc-search__clear');
      var suggest = section.querySelector('.icc-suggest');
      var emptyEl = section.querySelector('[data-icc-empty]');
      var resultEl = section.querySelector('[data-icc-result]');
      var noresultEl = section.querySelector('[data-icc-noresult]');
      var titleEl = section.querySelector('[data-icc-title]');
      var yearEl = section.querySelector('[data-icc-year]');
      var positionsEl = section.querySelector('[data-icc-positions]');
      var airbagEl = section.querySelector('[data-icc-airbag]');
      var seatEls = section.querySelectorAll('.icc-seat');
      var shareBtn = section.querySelector('[data-icc-share]');
      var printBtn = section.querySelector('[data-icc-print]');
      var chips = section.querySelectorAll('.icc-chip');

      var flatIndex = [];
      var activeSuggestion = -1;
      var currentSuggestions = [];
      var fullData = null;
      var currentProduct = 'cocoon';
      var currentMode = 'default';

      var positionLabels = {
        1: 'Front passenger',
        2: 'Rear left',
        3: 'Rear centre',
        4: 'Rear right',
        5: 'Third row left',
        6: 'Third row centre',
        7: 'Third row right'
      };

      function loadData() {
        if (window.__iccData) return window.__iccData;
        var mainP = fetch(dataUrl, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
        var bbP = bbDataUrl
          ? fetch(bbDataUrl, { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; })
          : Promise.resolve(null);
        window.__iccData = Promise.all([mainP, bbP]).then(function (res) {
          var data = res[0] || { products: {} };
          if (!data.products) data.products = {};
          var bb = res[1];
          if (bb) {
            // accept either { products: { baby_beyond: {...} } } or the bare product node
            var node = (bb.products && bb.products.baby_beyond) ? bb.products.baby_beyond : bb;
            if (node && node.modes) data.products.baby_beyond = node;
          }
          return data;
        });
        return window.__iccData;
      }

      function rebuildIndex() {
        var dataKey = currentProduct;
        if (!fullData || !fullData.products) {
          flatIndex = [];
          return;
        }
        // If Baby & Beyond's own data isn't present yet, fall back to Cocoon's list
        if (!fullData.products[dataKey]) {
          if (currentProduct === 'baby_beyond' && fullData.products.cocoon) {
            dataKey = 'cocoon';
          } else {
            flatIndex = [];
            return;
          }
        }
        var product = fullData.products[dataKey];
        var mode = product.modes[currentMode];
        if (!mode) {
          // Fall back to first available mode
          currentMode = Object.keys(product.modes)[0];
          mode = product.modes[currentMode];
        }
        var arr = [];
        Object.keys(mode.brands).forEach(function (brand) {
          mode.brands[brand].forEach(function (entry) {
            var display = prettyModel(entry.model);
            arr.push({
              brand: brand,
              model: entry.model,
              display: display,
              year: entry.year,
              seats: entry.seats,
              isize: !!entry.isize,
              // search both the raw model and the tidied "Mark N" form
              haystack: (brand + ' ' + entry.model + ' ' + display + ' ' + entry.year).toLowerCase()
            });
          });
        });
        flatIndex = arr;
      }

      function getCategory() {
        // Cocoon → infant card; Baby & Beyond → toddler card
        return currentProduct === 'baby_beyond' ? 'toddler' : 'infant';
      }

      function search(q) {
        q = q.trim().toLowerCase();
        if (!q || q.length < 2) return [];
        var tokens = q.split(/\s+/);
        var matches = flatIndex.filter(function (e) {
          for (var i = 0; i < tokens.length; i++) {
            if (e.haystack.indexOf(tokens[i]) === -1) return false;
          }
          return true;
        });
        matches.sort(function (a, b) {
          var aBrand = a.brand.toLowerCase().indexOf(tokens[0]);
          var bBrand = b.brand.toLowerCase().indexOf(tokens[0]);
          if (aBrand === 0 && bBrand !== 0) return -1;
          if (bBrand === 0 && aBrand !== 0) return 1;
          var aModel = a.model.toLowerCase().indexOf(tokens[0]);
          var bModel = b.model.toLowerCase().indexOf(tokens[0]);
          if (aModel === 0 && bModel !== 0) return -1;
          if (bModel === 0 && aModel !== 0) return 1;
          return a.haystack.localeCompare(b.haystack);
        });
        return matches.slice(0, 12);
      }

      function renderSuggest(items) {
        currentSuggestions = items;
        activeSuggestion = -1;
        if (!items.length) {
          if (input.value.trim().length >= 2) {
            suggest.innerHTML = '<li class="icc-suggest__empty">No matches. Try a different make or model.</li>';
            suggest.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          } else {
            suggest.hidden = true;
            input.setAttribute('aria-expanded', 'false');
          }
          return;
        }
        var html = items.map(function (item, i) {
          return '<li class="icc-suggest__item" role="option" data-i="' + i + '" id="icc-opt-' + i + '">'
            + '<span class="icc-suggest__brand">' + escapeHtml(item.brand) + '</span>'
            + '<span class="icc-suggest__model">' + escapeHtml(item.display) + '</span>'
            + '<span class="icc-suggest__year">' + escapeHtml(item.year) + '</span>'
            + '</li>';
        }).join('');
        suggest.innerHTML = html;
        suggest.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function selectSuggestion(item) {
        input.value = item.brand + ' ' + item.display;
        clearBtn.hidden = false;
        suggest.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        showResult(item);
      }

      function showResult(item) {
        emptyEl.hidden = true;
        noresultEl.hidden = true;
        resultEl.hidden = false;
        resultEl.classList.remove('is-in');

        titleEl.textContent = item.brand + ' ' + item.display;
        yearEl.textContent = item.year;

        var seatSet = {};
        item.seats.forEach(function (n) { seatSet[n] = true; });

        seatEls.forEach(function (s) {
          var n = parseInt(s.getAttribute('data-seat'), 10);
          if (seatSet[n]) {
            s.setAttribute('data-state', n === 1 ? 'warn' : 'yes');
          } else {
            s.setAttribute('data-state', 'no');
          }
        });

        positionsEl.innerHTML = item.seats.map(function (n) {
          var warn = n === 1 ? ' data-warn="true"' : '';
          return '<li' + warn + '><span class="icc-positions__num">' + n + '</span>'
            + (positionLabels[n] || ('Position ' + n)) + '</li>';
        }).join('');

        if (airbagEl) airbagEl.hidden = !seatSet[1];

        // Cross-sell: show product matching the current car-seat category if there's any compatible seat
        renderCrosssell(item.seats.length > 0);

        // Trigger entrance animation
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            resultEl.classList.add('is-in');
          });
        });

        // Smooth scroll to result on mobile (where panels stack)
        if (window.matchMedia('(max-width: 879px)').matches) {
          setTimeout(function () {
            resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }

        // Push state for shareable URLs
        try {
          var slug = (item.brand + '-' + item.model + '-' + item.year)
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          history.replaceState(null, '', '#car=' + slug);
        } catch (e) {}
      }

      function renderCrosssell(show) {
        var card = section.querySelector('[data-icc-crosssell]');
        if (!card) return;
        if (!show) {
          card.hidden = true;
          return;
        }
        var category = getCategory();
        var prefix = category === 'toddler' ? 'toddler' : 'infant';
        var title = section.getAttribute('data-' + prefix + '-title') || '';
        var desc = section.getAttribute('data-' + prefix + '-desc') || '';
        var price = section.getAttribute('data-' + prefix + '-price') || '';
        var link = section.getAttribute('data-' + prefix + '-link') || '';
        var img = section.getAttribute('data-' + prefix + '-image') || '';
        var ctaText = section.getAttribute('data-crosssell-cta') || 'Shop now';

        // If there's no link configured, skip the card (avoids broken CTA)
        if (!link) {
          card.hidden = true;
          return;
        }

        var crossTitleEl = card.querySelector('[data-icc-cross-title]');
        var crossDescEl = card.querySelector('[data-icc-cross-desc]');
        var crossPriceEl = card.querySelector('[data-icc-cross-price]');
        var crossLinkEl = card.querySelector('[data-icc-cross-link]');
        var crossImgEl = card.querySelector('[data-icc-cross-img]');
        var crossCtaEl = card.querySelector('[data-icc-cross-cta-text]');

        if (crossTitleEl) crossTitleEl.textContent = title;
        if (crossDescEl) crossDescEl.textContent = desc;
        if (crossPriceEl) crossPriceEl.textContent = price;
        if (crossLinkEl) crossLinkEl.href = link;
        if (crossImgEl) {
          crossImgEl.src = img;
          crossImgEl.alt = title;
        }
        if (crossCtaEl) crossCtaEl.textContent = ctaText;
        card.hidden = false;
      }

      function clearResult() {
        resultEl.classList.remove('is-in');
        resultEl.hidden = true;
        emptyEl.hidden = false;
        noresultEl.hidden = true;
        var card = section.querySelector('[data-icc-crosssell]');
        if (card) card.hidden = true;
        if (history.replaceState) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      // Roman numerals used for vehicle generations (1–12). Map kept explicit
      // so we never convert stray single letters that happen to look Roman.
      var ROMAN_GEN = {
        I: 1, II: 2, III: 3, IV: 4, V: 5, VI: 6,
        VII: 7, VIII: 8, IX: 9, X: 10, XI: 11, XII: 12
      };

      // Tidy a raw model string for display:
      //  • drops the bodystyle word "Variant" (e.g. "Golf VI Variant" → "Golf VI")
      //  • turns a generation Roman numeral into "Mark N" (e.g. "Golf VI" → "Golf Mark 6")
      // Guards against false positives: skips "Model X" (Tesla) and "V Class" / "X Class" (Mercedes).
      function prettyModel(model) {
        if (!model) return model;
        var tokens = String(model).split(/\s+/);
        var out = [];
        for (var i = 0; i < tokens.length; i++) {
          var tok = tokens[i];
          if (/^variant$/i.test(tok)) continue; // remove "Variant"
          var gen = ROMAN_GEN[tok]; // exact, case-sensitive uppercase match
          var prev = tokens[i - 1];
          var next = tokens[i + 1];
          var prevIsModel = prev && /^model$/i.test(prev);      // Tesla "Model X"
          var nextIsClass = next && /^class$/i.test(next);      // Mercedes "V Class"
          if (gen && !prevIsModel && !nextIsClass) {
            out.push('Mark ' + gen);
          } else {
            out.push(tok);
          }
        }
        return out.join(' ').replace(/\s{2,}/g, ' ').trim();
      }

      function setActive(i) {
        var items = suggest.querySelectorAll('.icc-suggest__item');
        items.forEach(function (el) { el.removeAttribute('aria-selected'); });
        if (i >= 0 && i < items.length) {
          items[i].setAttribute('aria-selected', 'true');
          items[i].scrollIntoView({ block: 'nearest' });
        }
        activeSuggestion = i;
      }

      input.addEventListener('input', function () {
        var v = input.value;
        clearBtn.hidden = !v;
        renderSuggest(search(v));
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2) {
          renderSuggest(search(input.value));
        }
      });

      input.addEventListener('keydown', function (e) {
        var items = suggest.querySelectorAll('.icc-suggest__item');
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setActive(Math.min(activeSuggestion + 1, items.length - 1));
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setActive(Math.max(activeSuggestion - 1, 0));
        } else if (e.key === 'Enter') {
          if (activeSuggestion >= 0 && currentSuggestions[activeSuggestion]) {
            e.preventDefault();
            selectSuggestion(currentSuggestions[activeSuggestion]);
          } else if (currentSuggestions.length === 1) {
            e.preventDefault();
            selectSuggestion(currentSuggestions[0]);
          }
        } else if (e.key === 'Escape') {
          suggest.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      });

      suggest.addEventListener('mousedown', function (e) {
        var li = e.target.closest('.icc-suggest__item');
        if (!li) return;
        e.preventDefault();
        var i = parseInt(li.getAttribute('data-i'), 10);
        if (!isNaN(i) && currentSuggestions[i]) {
          selectSuggestion(currentSuggestions[i]);
        }
      });

      document.addEventListener('click', function (e) {
        if (!section.contains(e.target)) {
          suggest.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      });

      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        suggest.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        clearResult();
        input.focus();
      });

      // Quick-pick chips
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var term = chip.getAttribute('data-quick');
          input.value = term;
          clearBtn.hidden = false;
          input.focus();
          var results = search(term);
          if (results.length === 1) {
            selectSuggestion(results[0]);
          } else if (results.length > 0) {
            // Auto-pick the earliest year match for the brand
            selectSuggestion(results[0]);
          }
        });
      });

      // Share button
      if (shareBtn) {
        shareBtn.addEventListener('click', function () {
          var url = window.location.href;
          if (navigator.share) {
            navigator.share({
              title: 'iCandy car seat compatibility — ' + (titleEl.textContent || ''),
              text: 'Check iCandy car seat compatibility for ' + (titleEl.textContent || '') + ' ' + (yearEl.textContent || ''),
              url: url
            }).catch(function () {});
          } else if (navigator.clipboard) {
            navigator.clipboard.writeText(url).then(function () {
              var orig = shareBtn.textContent;
              shareBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" fill="currentColor"/></svg> Copied';
              setTimeout(function () {
                shareBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4"/><path d="m8 8 4-4 4 4"/><path d="M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4"/></svg> Share';
              }, 1800);
            });
          }
        });
      }

      // Print button
      if (printBtn) {
        printBtn.addEventListener('click', function () { window.print(); });
      }

      // Picker event handlers
      var productBtns = section.querySelectorAll('[data-product]');

      function setActiveButton(btns, attr, value) {
        btns.forEach(function (b) {
          var active = b.getAttribute(attr) === value;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
      }

      function setProduct(p) {
        currentProduct = p;
        currentMode = 'default';
        setActiveButton(productBtns, 'data-product', p);
        rebuildIndex();
        // Clear current result + input since data set has changed
        input.value = '';
        clearBtn.hidden = true;
        clearResult();
      }

      productBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          setProduct(b.getAttribute('data-product'));
        });
      });

      // Init
      Promise.resolve(loadData()).then(function (json) {
        if (!json) return;
        fullData = json;
        // Default state: Cocoon
        currentProduct = 'cocoon';
        currentMode = 'default';
        setActiveButton(productBtns, 'data-product', 'cocoon');
        rebuildIndex();

        if (window.location.hash.indexOf('#car=') === 0) {
          var slug = window.location.hash.replace('#car=', '');
          var match = flatIndex.find(function (e) {
            var s = (e.brand + '-' + e.model + '-' + e.year)
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/(^-|-$)/g, '');
            return s === slug;
          });
          if (match) selectSuggestion(match);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
